/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import { Component, EventEmitter, Output, Input } from '@angular/core';
import { LocationInstance } from '../../models/location-instance';
import { LocationService } from '../../services/location.service';

@Component({
    selector: 'app-sites-header-nav',
    templateUrl: './sites-header-nav.component.html'
})
export class SitesHeaderNavComponent {

    @Input()
    set location(location: LocationInstance) {
        console.log("SitesHeaderNav - Set Location: " + (location == null ? "*NULL*" : (location.id + "/" + location.name)));
        this.refreshLocationList(location);
    }

    @Output()
    locationClicked = new EventEmitter<LocationInstance>();

    mLocations: LocationInstance[] = [];
    mLocation: LocationInstance = null;
    mParentLocations: LocationInstance[] = [];




    constructor(
        private mLocationService: LocationService
    ) { }

    async refreshLocationList(location: LocationInstance): Promise<void> {
        const locationList: LocationInstance[] = [];
        const parentLocationList: LocationInstance[] = [];
        if (location != null) {
            locationList.push(location);

            let otherLocation = location;
            while (otherLocation.parent != null && otherLocation.parent.instance != null) {
                otherLocation = await this.mLocationService.getLocationInstanceById(otherLocation.parent.instance.id);
                if (otherLocation != null) {
                    locationList.push(otherLocation);
                    parentLocationList.push(otherLocation);
                }
            }
        }
        this.mLocations = locationList.reverse();

        this.mLocation = location;
        this.mParentLocations = parentLocationList.reverse();
    }

}
